// Guard the parent class - SearchForm lives in search-form.js; only define if loaded.
if (typeof SearchForm === 'undefined') {
  console.warn('[main-search] SearchForm base class not loaded; main-search element will not be defined.');
} else if (!customElements.get('main-search')) {
class MainSearch extends SearchForm {
  connectedCallback() {
    if (this._abort && !this._abort.signal.aborted) return;
    super.connectedCallback();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const signal = this._abort.signal;
    let allSearchForms = [];
    this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
    this.input.addEventListener('focus', this.onInputFocus.bind(this), { signal });
    if (allSearchForms.length < 2) return;
    [...new Set(allSearchForms)].filter(form => form && form !== this.input.form).forEach(form =>
      form.addEventListener('reset', this.onFormReset.bind(this), { signal })
    );
    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this), { signal })
    );
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 768;
    if (isSmallScreen) {
      this.scrollIntoView({behavior: 'smooth'});
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
}
